import { Box } from '@bechtel/gds';
import { Skeleton } from '../skeleton';

export const GridHeaderSkeleton = () => {
  return (
    <Box flexDirection={{ sm: 'column' }} pt={{ sm: '450' }} px={{ sm: '450' }} gap={{ sm: '450' }}>
      <Box>
        <Box style={{ gap: '1%' }} flexGrow={{ sm: '1' }}>
          <Skeleton width="50%" height="40px" borderRadius="200" />
          <Skeleton width="40%" height="40px" borderRadius="200" />
        </Box>
        <Box justifyContent={{ sm: 'flex-end' }} flexGrow={{ sm: '1' }}>
          <Skeleton width="7%" height="40px" borderRadius="200" />
        </Box>
      </Box>
    </Box>
  );
};
